var render = function render(){var _vm=this,_c=_vm._self._c;return _c('export-excel',{staticClass:"ma-0",attrs:{"data":_vm.computedValue,"fields":_vm.dataFields,"type":"xls","name":_vm.name,"before-generate":_vm.beforeGenerate}},[_c('v-btn',{staticClass:"ma-0",attrs:{"dark":"","color":"success","small":"","block":""}},[_c('span',[_vm._v("Export Excel V2")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }